import React, { useState, useEffect } from "react";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import RequestTranslationAgainVendor from "./RequestTranslationAgainVendor";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import OverviewAlerts from "./OverviewAlerts";
import Constants from "../../../Constants";

export default function TranslationRequest(prop) {

  const [translationRequest, setTranslationRequest] = useState([]);
  const [bidDetail,setBidDetail] = useState({})
  const [showRequestTranslationVendor,setShowRequestTranslationVendor] = useState(false) 
  const param = useParams();
  const projectStatus = prop?.projectDetail?.displayName[0].status
  const projectResource = prop?.projectDetail?.resource.projectResource;
  
  const refreshProject = () => {
    prop.refresh("internalTranslator");
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.GET_BID_REQUEST_PROJECT(param.id))
      .then((res) => {
        if (res.data !== "") {
          setTranslationRequest(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

      getAxiosResponse(APIUrls.BID_REQUEST_BY_ID(projectResource.id))
      .then((res)=>{
        setBidDetail(res.data.data)
      }).catch(err=>{
        console.error(err)
      })
  }, []);
  const showRequestTranslationAgainModel = () => {
    document.body.classList.add("modal-open-7");
  };
  const hideRequestTranslationAgainModel = () => {
    document.body.classList.remove("modal-open-7");
  };
  const showRequestTranslationAgainAlertModel = () => {
    if(projectStatus.code === "vendor_rejected"){
      if (showRequestTranslationVendor) {
        setShowRequestTranslationVendor(false);
        hideRequestTranslationAgainModel();
      } else {
        setShowRequestTranslationVendor(true);
        showRequestTranslationAgainModel();
      }
    }
  };

  return (
    <div className="listing-content relative">
      {projectStatus?.code === "vendor_rejected" ? 
      <div className="mar-bot15">
          <OverviewAlerts project={prop.projectDetail} requestTranslationAgainFunct={showRequestTranslationAgainAlertModel}
          refresh={refreshProject} />
        </div> : ''}
      <div className="campaign_details-task campaign-form">
        <div className="projects-heading">
          <h5>Translation Request</h5>
        </div>
        <div className="projects-content">
          
          <div className="table-responsive global-table">
            {translationRequest.length > 0 ? (
              <table className="sortable" aria-label="Translation Request">
                <thead>
                  <tr>
                    <th scope="col" className="no-sort" aria-label="First Translation Deadline">
                      First Translation Deadline
                    </th>
                    <th scope="col" className="no-sort" aria-label="Requested Date">
                      Requested Date
                    </th>
                    <th scope="col" className="no-sort" aria-label="Preferred Vendor">
                      Preferred Vendor
                    </th>
                    <th scope="col" className="no-sort" aria-label="Reason for Rejection">
                      Reason for Rejection
                    </th>
                    <th scope="col" className="no-sort" aria-label="Status">
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {translationRequest.map((request, index) => {
                    return (
                      <tr key={index}>
                        <td aria-label={prop.projectDetail.resource.projectResource.deliveryDueDate?.dateWithTime}>
                          {prop.projectDetail.resource.projectResource.deliveryDueDate?.dateWithTime}
                        </td>
                        <td aria-label={request.resource.createdDate?.dateWithTime}>
                          {request.resource.createdDate.dateWithTime}
                        </td>
                        <td aria-label={request.resource.vendor?.name}>
                          {request?.resource?.vendor?.name}
                        </td>
                        <td aria-label={request?.resource?.rejectionReason !== '' ? request?.resource?.rejectionReason : 'not provided'}>
                          {request?.resource?.rejectionReason !== '' ? request?.resource?.rejectionReason : 'N/A'}
                        </td>
                        <td aria-label={request.displayName[0].display}>
                          {Constants.BIDLESS[request.resource.status.code.toUpperCase()]}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : projectStatus?.preparingProject ? (
              <p> OPAL-Marketing is preparing this project for translation. Check back in a few minutes.</p>
            ) : <div className="project-information project-detail-page">
            <div className= "bids-table">
              <ul>
                <li>
                  <div className="title">First Translation Deadline</div>
                  <div className="text">
                  {projectResource?.deliveryDueDate?.dateWithTime}
                  </div>
                </li>
                <li>
                  <div className="title">Preferred Vendor</div>
                  {bidDetail?.preferredVendors ?
                  <div className="text">{bidDetail?.preferredVendors[0].name}</div> : ''}
                </li>
                
              </ul>
            </div>
          </div>
          }
          </div>
        </div>
      </div>
      {showRequestTranslationVendor && (
        <RequestTranslationAgainVendor projectDetails={prop.projectDetail} popupState={showRequestTranslationAgainAlertModel} refresh={refreshProject}/>
      )}
    </div>
  );
}
